export class StringUtil {

  static removeNonNumber(input: string): string {
    return input.replace(/\D/g, "");
  }

  static removeSpecialCharacters(nome: string) {
    nome = nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return nome;
  }
}
